BookingsEditController.$inject = [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'CONST',
    'Club',
    'User',
    'Sports',
    'Time',
    '_',
    'deps',
    'alerts',
    'PlayersHistory',
    'BookingTypeMetadataEditModal',
    'moment',
    'BookingChangeDateModal',
    'PlayersOffline',
    'Backoffice',
    'disabled_features',
];

/* @ngInject */
function BookingsEditController(
    $scope,
    $rootScope,
    $uibModalInstance,
    CONST,
    Club,
    User,
    Sports,
    Time,
    _,
    deps,
    alerts,
    PlayersHistory,
    BookingTypeMetadataEditModal,
    moment,
    BookingChangeDateModal,
    PlayersOffline,
    Backoffice,
    disabled_features,
) {
    var vm = this;

    var booking = deps.booking;
    var court = booking.court;
    vm.courtName = court.name;
    vm.currentCourtID = court.id;

    vm.can_cancel = Club.can_cancel ? true : false;

    vm.viewMode = deps.def_mode || 'info';

    var date = deps.day.clone().startOf('day');
    var event_date = deps.day.clone().startOf('day');

    vm.showCourtDropDown = false;

    vm.min_end = event_date.clone().add(1, 'week').toDate();

    vm.dateOptions = {
        initDate: vm.min_end,
        dateDisabled: false,
        formatYear: 'yy',
        minDate: vm.min_end,
        startingDay: 1,
        showWeeks: false,
    };
    // vm.bookingCopyText = "Booking Id"

    var hour = booking.attrs.start;

    date.add(hour.hour, 'hours').add(hour.min, 'minutes');

    vm.close = function (update) {
        if (update) {
            deps.update();
        }
        $uibModalInstance.close(true);
    };

    vm.remove = function () {
        deps.remove();
        $uibModalInstance.close(true);
    };

    vm.courts = [];

    vm.editBookingCourt = function () {
        if (
            deps.booking.attrs.start.hour == 24 &&
            deps.booking.attrs.start.min == 0
        ) {
            date = Time.moment(date).add(1, 'days');
        }

        BookingChangeDateModal.open({
            ...vm,
            deps,
            ngModel: { day: vm.day, date },
        });
    };

    vm.copyBookingId = async function () {
        try {
            await navigator.clipboard.writeText(booking.id);
            const tooltip = document.querySelector(
                '[uib-tooltip-popup] > .tooltip-inner',
            );
            tooltip.textContent = `¡Copiado!`;
        } catch (e) {
            console.log(e);
        }
    };

    vm.updateCourt = function () {
        var d = vm.dynamic_duration.model;
        date.set({ hour: d.getHours(), minute: d.getMinutes() });
        alerts
            .verifyCode(null, null, User)
            .then(
                updateCourt.bind(null, {
                    booking_id: vm.booking.id,
                    is_done: vm.booking.done ? true : false,
                    court_id: vm.currentCourtID,
                    datetime: date.format('YYYY-MM-DD HH:mm'),
                }),
            )
            .catch((error) => {
                alerts.errorHandler(error);
            });
    };

    if (hour.hour >= 24) {
        deps.day = Time.moment(deps.day).add(1, 'days');
    }

    function updateCourt(data, {code}) {
        data.code = code;
        vm.booking
            .api()
            .one('check_overlap')
            .customPOST(data)
            .then(function (res) {
                alerts.success(
                    '¡Exito!',
                    'Se ha actualizado el evento correctamente',
                );
                vm.showCourtDropDown = false;
                deps.refresh();
                $uibModalInstance.close(true);
            })
            .catch(alerts.errorHandler)
            .finally(function () {
                vm.loading_new = false;
            });
    }

    // Basic ViewModel
    vm.day = deps.day.format('ddd DD[/]MM'); // Use the default one (not the sum)
    vm.hour = date.format('HH:mm');
    vm.date = date;
    vm.hasOnlinePayment = booking.hasPayment();
    vm.isMatch = booking.isMatch();

    vm.start = booking.attrs.start.toStringFormalized();
    vm.end = booking.attrs.end.toString();
    vm.isFixed = booking.isFixed();
    vm.isOnline = booking.isOnline();

    vm.sport = booking.getSport().name;
    vm.price = null;

    Club.API.customGET('calendar/dow', {
        date: date.format('Y-MM-DD'),
    })
        .then(function (res) {
            vm.price = Number(booking.getPrice(res.dow));
        })
        .catch((error) => {
            alerts.error(
                '¡Error!',
                'No pudimos obtener el valor de la cancha. Por favor contáctate con el área de Soporte.',
            );
            vm.close();
        });
    vm.discount = booking.attrs.discount;
    vm.can_discount =
        !booking.isDone() &&
        (User.hasPermission('MANAGER') ||
            User.hasPermission('MANAGER_WO_CODE'));
    vm.created = booking.getCreated();
    vm.booking = booking;
    vm.bookingAttrs = booking.attrs;

    vm.canCashout = booking.canCashout(vm.date);

    vm.show_edit_date = false;
    vm.show_edit_balance = false;
    vm.payment_type = 'cash';
    vm.loading_advance = false;
    vm.phone_number_input = booking.attrs.user.phone;

    vm.validateInput = function () {
        const input = document.querySelector('#player_phone_edit');
        const iti = intlTelInput.getInstance(input);
        if (!input.value.trim()) {
            vm.edit.player.phone = undefined;
            vm.editPlayerForm.player_phone.$valid = false;
            vm.editPlayerForm.player_phone.$invalid = true;
            vm.editPlayerForm.$invalid = true;
            return;
        }
        if (iti.isValidNumber()) {
            vm.edit.player.phone = iti.getNumber();
            vm.editPlayerForm.player_phone.$valid = true;
            vm.editPlayerForm.player_phone.$invalid = false;
            vm.editPlayerForm.$invalid = false;
            return;
        }
        vm.edit.player.phone = undefined;
        vm.editPlayerForm.player_phone.$valid = false;
        vm.editPlayerForm.player_phone.$invalid = true;
        vm.editPlayerForm.$invalid = true;
    };

    // Define event
    activate();

    $scope.$watch('vm.edit.balance', function (newVal) {
        vm.balance_abs = Math.abs(newVal).toFixed(2);
    });

    function getPlayerOwes() {
        Club.API.customGET('players', {
            phone: vm.event.player.phone,
        })
            .then(function (player) {
                vm.event.player.owes_count = player.owes_count;
                vm.event.player.no_wine = player.no_wine;
            })
            .catch(angular.noop);
    }

    getPlayerOwes();

    if (vm.event.booking.fixed) {
        var end_date_txt,
            current_txt = '';
        var end_date = vm.booking.getEndDate();

        if (end_date) {
            vm.current_end_date = end_date.clone();
            var weeks = vm.booking.getEndDate().diff(event_date, 'weeks');
            end_date_txt = event_date
                .clone()
                .add(weeks, 'weeks')
                .format('DD-MM-YYYY');
            current_txt = end_date.format('DD-MM-YYYY');
        }
        vm.show_text = {
            weeks: vm.booking.getWeeksToPlay(),
            since_date: vm.booking.getSinceDate(true),
            end_date: end_date_txt,
            current: current_txt,
        };
    }

    // View Changes
    vm.cancelMode = function () {
        vm.viewMode = 'delete';
        vm.cancelView = true;
        vm.reportView = false;
    };
    vm.reportMode = function () {
        vm.viewMode = 'delete';
        vm.reportView = true;
        vm.cancelView = false;
    };
    vm.doneMode = function () {
        vm.viewMode = 'done';
    };
    vm.infoMode = function () {
        vm.viewMode = 'info';
    };
    vm.playerHistory = function (tab_owes) {
        if (booking.attrs.user.id) {
            PlayersHistory.open(
                booking.attrs.user,
                booking.isOnline(),
                tab_owes,
            );
        }
    };
    vm.showPlayers = function () {
        Club.openPlayersModal({
            onPhoneSelect: (phone) => {
                vm.edit.player.phone = phone;
                const input = document.querySelector('#player_phone_edit');
                const iti = intlTelInput.getInstance(input);
                iti.setNumber(phone);
            },
        });
    };
    vm.showAddPlayersBooking = function () {
        // Club.openPlayersBookingModal({
        //     user: (booking.attrs.user),
        //     onPhoneSelect: (phone) => (vm.edit.player.phone = phone),
        // });
        PlayersOffline.open(booking);
    };

    vm.enterAdvanceMode = function () {
        vm.viewMode = 'advance';
    };

    vm.should_impact_on_cash_movements = false;
    vm.balance_type = 'advance';
    vm.disabledAdvance = true;

    vm.submitAdvance = function () {
        vm.disabledAdvance = true;
        let newBalance = 0;
        newBalance =
            vm.balance_type === 'advance'
                ? Number(vm.edit.balance) + vm.advance_import
                : Number(vm.edit.balance) - vm.advance_import;

        const update_changes = { balance: newBalance };
        const update_params = {
            payment_type: vm.payment_type_advance,
            should_impact_on_cash_movements: true,
            observations: vm.observations,
        };

        alerts
            .verifyCode(null, null, User)
            .then(update.bind(null, update_changes, update_params))
            .catch((error) => {
                resetAdvanceFields();
                alerts.errorHandler(error);
            });
    };

    function resetAdvanceFields() {
        vm.loading_advance = false;
        vm.advance_import = undefined;
        vm.payment_type_advance = '';
        vm.balance_type = 'advance';
        vm.observations = '';
    }

    vm.editMetadata = function () {
        BookingTypeMetadataEditModal.open(vm.edit, {
            allowCancel: true,
            type: vm.event.booking.type.id,
            onSave: () =>
                vm.edit
                    .update({
                        type_metadata: vm.edit.type_metadata,
                    })
                    .then(
                        () =>
                            (vm.event.booking.type_metadata =
                                vm.edit.type_metadata),
                    ),
        });
    };

    vm.endDateUpdated = function () {
        var current = moment(vm.current_end_date);

        vm.show_edit_date = false;
        vm.popup1.opened = false;

        if (!current.isValid()) {
            return;
        }

        var weeks = current.diff(event_date, 'weeks');

        var end_date = event_date.clone().add(weeks, 'weeks');

        alerts
            .verifyCode(null, null, User)
            .then(
                update.bind(
                    null,
                    {
                        id: vm.booking.id,
                        datetime: vm.date.format('YYYY-MM-DD HH:mm'),
                        end: end_date.format('YYYY-MM-DD'),
                    },
                    null,
                ),
            )
            .catch((error) => {
                alerts.errorHandler(error);
            });
    };

    vm.doSearch = function (term) {
        console.log(term);
    };

    /**
     * Update the view with the new data.
     */
    function updateDateView() {
        var current = moment(vm.current_end_date);

        if (vm.booking.getEndDate()) {
            var weeks = vm.booking.getEndDate().diff(event_date, 'weeks');
            var end_date = event_date.clone().add(weeks, 'weeks');
            var end_date_text = end_date.format('DD-MM-YYYY');
            vm.event.booking.end = vm.current_end_date;
        }

        vm.show_text = {
            weeks: vm.booking.getWeeksToPlay(),
            since_date: vm.booking.getSinceDate(true),
            end_date: end_date_text,
            current: current.format('DD-MM-YYYY'),
        };
    }

    ////////////////

    function activate() {
        vm.event = parseBooking(booking);
    }

    function parseBooking(booking) {
        var user = booking.getUser();

        var duration_obj = _.find(booking.getSport().getFormattedDurations(), {
            value: booking.attrs.duration,
        });

        return {
            player: {
                id: user.id || null,
                name: user.name,
                phone: user.phone,
            },
            online: booking.isOnline(),
            type: booking.isFixed() ? 'once' : 'fixed',
            sport_id: booking.getSport().id,
            booking: {
                id: booking.id,
                fixed: booking.isFixed(),
                type: booking.getType(),
                type_metadata: booking.attrs.type_metadata,
                duration: duration_obj
                    ? duration_obj.name
                    : booking.attrs.duration + ' minutos',
                since: booking.isFixed() ? booking.getSinceDate() : null,
                end: booking.isFixed() ? booking.getEndDate() : null,
            },
        };
    }

    vm.canUpdateCourt = function () {
        var d = vm.dynamic_duration.model;

        return (
            vm.currentCourtID != vm.booking.court.id ||
            vm.booking.attrs.start.hour != d.getHours() ||
            vm.booking.attrs.start.min != d.getMinutes()
        );
    };

    /**
     * Returns the current booking date
     * @method getDate
     * @return {date}
     */
    vm.getDate = function () {
        if (!booking.isFixed()) {
            return booking.getDate().format('Y-MM-DD HH:mm');
        }

        var hour = booking.attrs.start,
            day = deps.day;

        return day.format('Y-MM-DD') + ' ' + hour.toStringFormalized();
    };

    vm.advance = {
        amount: booking.getAdvance(),
        partialPayment: booking.getPartialPayment.bind(booking),
        offlinePayment: booking.getRemaining.bind(booking),
        type: (function () {
            if (!booking.hasPayment()) {
                return null;
            }
            if (booking.payment.isCapture) {
                return 'Captura directa';
            } else {
                return 'Autorización de tarjeta';
            }
        })(),
    };

    vm.dynamic_duration = {
        model: (function () {
            var d = new Time.Hour();
            d.hour = vm.booking.attrs.start.hour;
            d.min = vm.booking.attrs.start.min;
            //d.addMinutes(vm.sport.data.default_duration);
            return d.toDate();
        })(),
        changed: function () {
            var d = vm.dynamic_duration.model;
            vm.duration_custom = d.getHours() * 60 + d.getMinutes();
        },
        /*min: (function() {
    var d = new Date();
    d.setHours(8);
    d.setMinutes(0);
    return d;
})() /*,
max: (function() {
    var d = new Date();
    d.setHours(24);
    d.setMinutes(0);
    return d;
})()*/
    };

    vm.getWhatsappLink = () =>
        vm.booking.attrs.user.phone &&
        vm.booking.attrs.user.phone.replace('+', '');

    /**
     * @class EditVM
     * @constructor
     * @param  {Booking} booking
     */
    vm.edit = {
        update: function (data) {
            return alerts
                .verifyCode(null, null, User)
                .then(update.bind(null, data, undefined))
                .catch((error) => {
                    alerts.errorHandler(error);
                });
        },
        balance: booking.attrs.balance,
        type_metadata: booking.attrs.type_metadata,
        note: booking.note.has()
            ? booking.note.get()
            : {
                  text: '',
              },
        player: {
            loaded: false,
            id: booking.attrs.user.id,
            name: booking.attrs.user.name,
            phone: booking.attrs.user.phone,
            email: null,
            loading: false,
            openEditForm: function () {
                vm.editPlayerForm.$show();
                vm.edit.player.fetch();
            },
            fetch: function () {
                if (vm.edit.player.loaded) {
                    return;
                }
                vm.edit.player.loading = true;
                Club.API.one('players', booking.attrs.user.id)
                    .get()
                    .then(function (playerOffline) {
                        var updateAttrs = _.pick(
                            playerOffline.plain(),
                            _.keys(vm.edit.player),
                        );
                        _.assign(vm.edit.player, updateAttrs);
                        vm.edit.player.loaded = true;
                    })
                    .catch(angular.noop)
                    .finally(function () {
                        vm.edit.player.loading = false;
                    });
            },
            update: function () {
                return alerts.verifyCode(null, null, User).then(
                    update.bind(
                        null,
                        {
                            player: {
                                phone: vm.edit.player.phone,
                                name: vm.edit.player.name,
                            },
                        },
                        null,
                    ),
                );
            },
        },
    };

    $scope.$watch('vm.popup1.opened', function (newValue, oldValue) {
        if (newValue === oldValue) {
            return;
        }

        if (newValue === false) {
            vm.show_edit_date = false;
        }
    });

    $rootScope.$on('pay:owes', function (event, data) {
        deps.refresh();
        getPlayerOwes();

        if (data.bookingIds.includes(booking.id)) {
            vm.edit.balance = 0;
        }
    });
    $scope.$watchGroup(
        ['vm.edit.player.phone', 'vm.editPlayerForm.player_phone.$valid'],
        function () {
            var $form = $scope.vm.editPlayerForm,
                valid =
                    $form && $form.player_phone
                        ? $form.player_phone.$valid
                        : false,
                phone = vm.edit.player.phone;

            vm.edit.player.id = null;
            if (!$form || !$form.$visible || !valid || !phone) return;

            vm.edit.player.loading = true;
            Club.API.customGET('players', {
                phone: vm.edit.player.phone,
            })
                .then(function (player) {
                    vm.edit.player.name = player.name;
                    vm.edit.player.id = player.id;
                })
                .catch(angular.noop)
                .finally(function () {
                    vm.edit.player.loading = false;
                });
        },
    );

    async function update(changes, params, { code, user_info }) {
        const should_impact_on_cash_movements =
            params?.should_impact_on_cash_movements;
        vm.loading_updates = true;
        vm.loading_advance = true;
        try {
            const cash_movement_response = await registerCashMovement(
                should_impact_on_cash_movements,
                user_info,
            );
            try {
                let booking = await vm.booking.api().customPUT({
                    code: code,
                    booking: changes,
                    ...params,
                });
                booking = booking.plain();
                _.assign(vm.edit, _.pick(booking, _.keys(vm.edit)));
                vm.booking.update(booking);

                if (booking.fixed) {
                    updateDateView();
                }
            } catch (error) {
                console.log(error);
                if (cash_movement_response) {
                    await Backoffice.api.undoRegisterCarts({
                        cash_movements: [{ id: cash_movement_response.id }],
                        stock_movements: [],
                    });
                    throw new Error(
                        'A ocurrido un error inesperado. Intente nuevamente',
                    );
                }
            }

            vm.infoMode();

            alerts.success(
                '¡Exito!',
                'Se ha realizado la accion correctamente.',
            );
        } catch (error) {
            //Sin el then, se comporta extraño el finally
            alerts.error('¡Error!', error.message).then(() => {});
        } finally {
            vm.disabledAdvance = true;
            vm.loading_updates = false;
            resetAdvanceFields();
        }
    }

    function registerCashMovement(
        should_impact_on_cash_movements = false,
        user_info = null,
    ) {
        const created_by = {
            user: user_info?.name ?? User.data.name,
            player: booking.attrs.user.name,
        };

        const concept_details = {
            booking_date: Time.moment(date).toISOString(true),
            court: booking.court.name,
            booking_id: booking.id,
        };

        if (should_impact_on_cash_movements) {
            const cash_movement = {
                value:
                    vm.balance_type === 'advance'
                        ? vm.advance_import * 100
                        : -vm.advance_import * 100,
                concept:
                    vm.balance_type === 'advance'
                        ? 'Cobro de Seña'
                        : 'Retiro de Seña',
                payment_method: vm.payment_type_advance,
                comment: vm.observations,
                created_by: JSON.stringify(created_by),
                movement_datetime: new Date().toISOString(),
                concept_details: JSON.stringify(concept_details),
                quantity: 0,
                item_id: null,
                is_advance: vm.balance_type === "advance",
                is_retire: vm.balance_type === "retire",
            };

            return Backoffice.api.registerCashMovement(cash_movement);
        }
        return Promise.resolve(null);
    }

    vm.disabledAdvanceButton = function () {
        const advance_import_input = document.getElementById(
            'advance_import_input',
        ).value;
        const payment_type_advance = document.getElementById(
            'payment_type_advance',
        ).value;

        if (advance_import_input >= 1 && payment_type_advance !== '') {
            vm.disabledAdvance = false;
        }
    };

    vm.setStyles = function () {
        const advance_import_input = document.getElementById(
            'advance_import_input',
        );

        Number(vm.advance_import) <= 0
            ? advance_import_input.style.setProperty(
                  'border',
                  '2px solid red',
                  'important',
              )
            : advance_import_input.style.setProperty(
                  'border',
                  '2px solid #009254',
                  'important',
              );
        vm.disabledAdvanceButton();
    };
}

export default BookingsEditController;
